import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);


export default new Router({
    mode: 'history',
    routes: [

        {
            path: '/',
            component: () => import("@/Frontend/Home/Home")
        },
        {
            path: '/Page/CustomerArea/PaymentRecordList',
            component: () => import("@/Frontend/CustomerArea/PaymentRecordList")
        },
        {
            path: '/Page/CustomerArea/PaymentRecordDetail/:OrderNo',
            component: () => import("@/Frontend/CustomerArea/PaymentRecordDetail")
        },

        {
            path: '/Backend/PaymentRecord/PaymentRecordList',
            component: () => import("@/Frontend/CustomerArea/PaymentRecordList")
        },
        {
            path: '/Backend/PaymentRecord/PaymentRecordDetail/:OrderNo',
            component: () => import("@/Frontend/CustomerArea/PaymentRecordDetail")
        },

        {
            path: '/Test/Test',
            component: () => import("@/Test/Test")
        },

        {
            path: '/Test/Refund',
            component: () => import("@/Test/Refund")
        },
        {
            path: '/Test/TestLineConfirm',
            component: () => import("@/Test/TestLineConfirm")
        },


        {
            path: '/Payment/Tspg/AuthCallback',
            component: () => import("@/Payment/Tspg/AuthCallback")
        },

        {

            path: '/Test/TestPostback',
            component: () => import("@/Test/TestPostback")

        },

        {

            path: '/Frontend/TspgPostBack',
            component: () => import("@/Frontend/TspgPostBack")
        },


        {

            path: '/FileNotFound',
            component: () => import("@/FileNotFound")
        },

        {
            path: '*',
            component: () => import("@/FileNotFound")
        },
    ]
})
